/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'

const menuLinks = [
  {
    name: 'ERP Ayarları',
    icon: '/media/icons/custom/settings-3.svg',
    desc: '...',
    link: '/settings/api-keys',
  },
  {
    name: 'E-Ticaret Ayarları',
    icon: '/media/icons/custom/settings-3.svg',
    desc: '...',
    link: '/settings/api-keys',
  },
  {
    name: 'Entegrasyon Ayarları',
    icon: '/media/icons/custom/settings-1.svg',
    desc: '...',
    link: '/settings/integration/ProductIntegration',
  },
  {
    name: 'Lisans Bilgisi',
    icon: '/media/icons/custom/cmd.svg',
    desc: '...',
    link: '/settings/licence',
  },
]

const QuickLinks: FC = () => (
  <div
    className='menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px'
    data-kt-menu='true'
  >
    <div
      className='d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10'
      style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
    >
      <h3 className='text-white fw-bold mb-3'>Hızlı Linkler</h3>
    </div>

    <div className='row g-0'>
      {menuLinks.map((item, index) => (
        <div className='col-6' key={index}>
          <Link
            to={item.link}
            className='d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom'
          >
            <KTSVG path={item.icon} className='svg-icon-3x svg-icon-primary mb-2' />
            <span className='fs-5 fw-bold text-gray-800 mb-0'>{item.name}</span>
            <span className='fs-7 text-gray-400'>{item.desc}</span>
          </Link>
        </div>
      ))}
    </div>
  </div>
)

export {QuickLinks}
